export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          爆料投稿
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-secondary-200/60 rounded-2xl p-8 md:p-10">
            <div className="text-center mb-8">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-xl">
                <i className="ri-mail-add-line text-3xl text-accent-600"></i>
              </div>
              <h3 className="text-xl font-bold text-foreground-900 mb-2 font-heading">
                你有猛料？欢迎投稿
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed max-w-lg mx-auto">
                五一黑料网面向全网征集最新黑料吃瓜线索与瓜田爆料内幕。如果您掌握娱乐圈、网红圈、社会热点等领域的独家爆料信息，欢迎通过以下方式联系我们。我们承诺对投稿人信息严格保密。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="text-center p-4 rounded-xl bg-background-100 border border-secondary-200/60">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center">
                  <i className="ri-mail-line text-2xl text-primary-600"></i>
                </div>
                <span className="text-xs text-foreground-500 block mb-1">投稿邮箱</span>
                <span className="text-sm font-semibold text-foreground-900">tips@wuyiheiliao.com</span>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 border border-secondary-200/60">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center">
                  <i className="ri-wechat-line text-2xl text-accent-600"></i>
                </div>
                <span className="text-xs text-foreground-500 block mb-1">微信爆料</span>
                <span className="text-sm font-semibold text-foreground-900">wuyiheiliaotips</span>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 border border-secondary-200/60">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center">
                  <i className="ri-message-3-line text-2xl text-foreground-700"></i>
                </div>
                <span className="text-xs text-foreground-500 block mb-1">在线提交</span>
                <span className="text-sm font-semibold text-foreground-900">24小时受理</span>
              </div>
            </div>

            <div className="p-4 bg-accent-50 border border-accent-200/60 rounded-xl">
              <p className="text-sm text-foreground-600 text-center leading-relaxed">
                <i className="ri-shield-check-line text-accent-600 mr-1"></i>
                <strong className="text-foreground-900">隐私保护承诺：</strong>
                所有投稿信息仅用于内容核实，投稿人身份信息将严格保密，绝不对外泄露。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}